export const rootRecipesRoute = 'recipes/';
export const getAllRecipesRoute = 'recipes/all';
export const postCreateRecipeRoute = 'recipes/create';
export const postUpdateRecipeRoute = 'recipes/update';
export const postDeleteRecipeRoute = 'recipes/delete';

export const getAllCategoriesRoute = 'recipes/categories/all';
export const postCreateCategoryRoute = 'recipes/categories/create';
export const postDeleteCategoryRoute = 'recipes/categories/delete';
